export default {
    // Return whether the Date objects represent the same date
    // Does not consider time
    isDateSame(date1, date2) {
        try {
            return (
                date1.getDate() === date2.getDate() &&
                date1.getMonth() === date2.getMonth() &&
                date1.getFullYear() === date2.getFullYear()
            );
        } catch {
            return false;
        }
    }
};
